import { styled } from "@mui/material";
import { useEffect } from "react";
import ClubSection from "./ClubSection";
import ProgramSection from "./ProgramSection";
import MemberSection from "./MemberSection";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { getTopProduct } from "../../../../redux/reducers/brandApp/thunks";
import { useSignedIn } from "@/utils/hooks/useSignedIn";
import DtcGetAppComponent from "@/components/Checkout/components/DtcGetApp/DtcGetAppComponent";

const Container = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: "80px",
  alignItems: "center",
});

const MembershipProgram = () => {
  const { signedIn } = useSignedIn();
  const navigate = useNavigate();
  useEffect(() => {
    if (signedIn) {
      navigate("/", { replace: true });
    }
  }, [signedIn, navigate]);
  const { appConfig } = useAppSelector((state) => state);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (appConfig?.domainConfig?.brandId) {
      dispatch(getTopProduct({ brandId: appConfig?.domainConfig?.brandId }));
    }
  }, [appConfig?.domainConfig?.brandId, dispatch]);

  return (
    <Container>
      <ClubSection />
      <ProgramSection />
      <DtcGetAppComponent
        type="membership"
        className="membership-program-get-app-component"
      />
      <MemberSection />
    </Container>
  );
};

export default MembershipProgram;
